export default ({date, className}:{date:string, className?:string}) => {
    const dateObj = new Date(date)
    const formatted = dateObj.toLocaleString()
    return <span title={date} className={`whitespace-nowrap ${className}`}>{formatted}</span>
}